<template>
  <div class="farm-item-box">
    <div
      @click="
        e => {
          handleShowClick(item, index, e);
        }
      "
      :class="[
        'item',
        {
          'is-active': item.show,
          'is-disabled': item.wholeDisable
        }
      ]"
      :key="index"
      v-for="(item, index) in dataList"
    >
      <div>
        {{ item.name }}
      </div>

      <!-- <div
        v-if="getResultText(item.name) === '取消' && item.name === '道路'"
        class="result-show"
        @click.stop="handleSaveRoadClick(item)"
      >
        保存
      </div>

      <div
        v-if="item.resultBtn"
        :class="[
          'result-show',
          {
            'is-disabled': getResultDisabled(item.name)
          }
        ]"
        @click.stop="handleResultClick(item, index)"
      >
        {{ getResultText(item.name) }}
      </div> -->

      <div
        v-if="item.tupuBtn"
        :class="[
          'button',
          {
            'is-disabled': getDisabled(item)
          }
        ]"
        @click.stop="handleTupuClick(item, index, getDisabled(item))"
      >
        <i
          :class="[
            'el-icon-view',
            {
              'is-active': item.tupuShow,
              'is-not-active': !item.tupuShow
            }
          ]"
        ></i>
        <!-- {{ item.tupuShow ? '隐藏' : '显示' }} -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    id: {
      type: Number,
      require: true
    }
  },
  data() {
    return {
      dataList: [
        {
          name: '资源',
          show: false,
          tupuShow: true,
          routerName: 'resource',
          tupuBtn: true,
          fengsuUrl: '',
          fenggonglvUrl: '',
          wholeDisable: false
        },
        {
          name: '风机',
          show: false,
          tupuShow: true,
          resultBtn: true,
          routerName: 'deploy',
          tupuBtn: true,
          fengsuUrl: '',
          fenggonglvUrl: '',
          wholeDisable: false
        },
        {
          name: '道路',
          show: false,
          tupuShow: true,
          resultBtn: true,
          fengsuUrl: '',
          tupuBtn: true,
          routerName: 'road',
          fenggonglvUrl: '',
          wholeDisable: false
        },
        {
          name: '线路',
          show: false,
          tupuShow: true,
          resultBtn: true,
          routerName: 'line',
          tupuBtn: true,
          fengsuUrl: '',
          fenggonglvUrl: '',
          wholeDisable: false
        },
        {
          name: '电量',
          show: false,
          tupuShow: true,
          tupuBtn: false,
          routerName: 'power',
          fengsuUrl: '',
          fenggonglvUrl: '',
          wholeDisable: false
        }
      ],
      flag: 0,
      activeItem: null
    };
  },
  watch: {
    dataList: {
      handler(val) {
        this.$store.commit('WindFarm/SET_FARM_LIST', val);
      },
      deep: true,
      immediate: true
    },
    turbineList(val) {
      this.dataList
        .filter(i => ['线路', '道路', '电量'].includes(i.name))
        .forEach(i => {
          i.wholeDisable = val.length === 0;
        });
    },
    activeTupu: {
      handler(val) {
        this.dataList[0].tupuShow = val == 0 || val == 1;
      }
    },
    immediate: true
  },
  computed: {
    ...mapGetters('WindFarm', [
      'exclusiveList',
      'boosterList',
      'turbineList',
      'windfarmRoadList',
      'keyPointsList',
      'entrancePointList',
      'specificDragFlag',
      'specificEditFlag',
      'specificChangeFlag',
      'windfarmWireList',
      'activeTupu',
      'wrgInfoForm'
    ])
  },
  created() {
    this.$bus.$on('farmClick', this.handleShowClick);
  },
  mounted() {
    this.expand();
  },
  beforeDestroy() {
    this.$bus.$off('farmClick', this.handleShowClick);
  },
  methods: {
    getResultDisabled(_name) {
      const { name } = this.$route;

      if (_name === '风机' && name === 'deploy') {
        return true;
      }

      if (_name === '道路' && name === 'road') {
        return true;
      }

      return false;
    },
    getResultText(name) {
      if (name === '风机') {
        if (this.specificDragFlag) {
          return '取消';
        }
        return '结果调整';
      } else if (name === '道路') {
        if (this.specificEditFlag) {
          return '取消';
        }

        return '结果调整';
      } else if (name === '线路') {
        if (this.specificChangeFlag) {
          return '取消';
        }
        return '结果调整';
      } else {
        return '结果调整';
      }
    },
    getDisabled(item) {
      if (item.name === '风机') {
        return this.specificDragFlag;
      }

      if (item.name === '道路') {
        return this.specificEditFlag;
      }

      if (item.name === '线路') {
        return this.specificChangeFlag;
      }
    },
    expand() {
      const { name } = this.$route;
      const myItem = this.dataList.find(i => i.routerName === name);
      if (myItem) myItem.show = true;
    },
    handleShowClick(item, index) {
      if (typeof item === 'number') {
        index = item;
        item = this.dataList[item];
      }

      if (item.wholeDisable) {
        return;
      }

      if (this.specificDragFlag) {
        this.$bus.$emit('resultClickFj', res => {
          this.flag = res;
        });

        if (!this.flag) {
          return;
        }
      }

      if (this.specificEditFlag) {
        this.$nextTick(() => {
          this.$bus.$emit('resultClickDl', false);
        });
      }

      if (this.specificChangeFlag) {
        return this.$message.warning('正在线路调整中...');
      }

      if (!item.show) {
        this.dataList.forEach((i, _index) => {
          if (index !== _index) {
            i.show = false;
          }
        });
      }
      item.show = !item.show;
      if (item.show) {
        this.activeItem = item;
        this.activeItem.id = this.id;
      } else {
        this.activeItem = null;
      }

      this.$emit('showClick', this.activeItem);
    },
    handleSaveRoadClick(item) {
      if (item.wholeDisable) {
        return;
      }

      this.$bus.$emit('roadSaveClick');
    },
    handleResultClick(item, index) {
      if (this.getResultDisabled(item.name)) return;

      if (item.wholeDisable) return;
      //console.log(item, index);

      if (item.name === '风机') {
        if (!item.tupuShow) {
          this.handleTupuClick(item, index, this.getDisabled(item));
        }

        this.$nextTick(() => {
          this.$bus.$emit('resultClickFj');
        });
      }

      if (item.name === '道路') {
        if (!item.tupuShow) {
          this.handleTupuClick(item, index, this.getDisabled(item));
        }

        this.$nextTick(() => {
          this.$bus.$emit('resultClickDl');
        });
      }

      if (item.name === '线路') {
        if (!item.tupuShow) {
          this.handleTupuClick(item, index, this.getDisabled(item));
        }

        this.$nextTick(() => {
          this.$bus.$emit('resultClickXl');
        });
      }
    },
    handleTupuClick(item, index, disabled) {
      if (item.wholeDisable) {
        return;
      }

      if (disabled) {
        if (item.tupuShow) {
          return;
        }
      }

      if (this.specificDragFlag && item.name === '风机') {
        return;
      }

      item.tupuShow = !item.tupuShow;

      if (item.name === '资源') {
        // 点击展示隐藏资源逻辑

        if (this.activeTupu !== -1) {
          this.$store.commit('WindFarm/SET_TUPUOBJ', {});
          this.$store.commit('WindFarm/SET_ACTIVE_TUPU_INDEX', -1);
          return;
        }

        this.$store.commit('WindFarm/SET_ACTIVE_TUPU_INDEX', 0);

        if (this.wrgInfoForm?.hasTupu) {
          this.$fetch('/windfarm/windfarm/createWrgPic', {
            showError: true,
            params: {
              elementCode: 'wspd',
              windfarmId: this.wrgInfoForm.windfarmId
            }
          }).then(res => {
            const { data = {} } = res;
            this.$store.commit('WindFarm/SET_TUPUOBJ', data);
          });
        }
      }

      if (item.name === '风机') {
        const arr = [...this.exclusiveList];
        arr.forEach(i => {
          i.isShow = item.tupuShow;
        });

        const otherArr = [...this.boosterList];
        otherArr.forEach(i => {
          i.isShow = item.tupuShow;
        });

        const another = [...this.turbineList];

        another.forEach(i => {
          i.isShow = item.tupuShow;
        });

        this.$store.commit('WindFarm/SET_BOOSTERLIST', otherArr);
        this.$store.commit('WindFarm/UPDATE_BOOST_AREA', otherArr);
        this.$store.commit('WindFarm/SET_EXCLUSIVELIST', arr);
        this.$store.commit('WindFarm/UPDATE_LIMIT_AREA');
        this.$store.commit('WindFarm/SET_TURLIST', another);
        this.$store.commit('WindFarm/UPDATE_TUILIST');
      }

      if (item.name === '道路') {
        const arr = [...this.windfarmRoadList];
        arr.forEach(i => {
          i.isShow = item.tupuShow;
        });

        const otherArr = [...this.keyPointsList];
        otherArr.forEach(i => {
          i.isShow = item.tupuShow;
        });

        sessionStorage.setItem(
          'CURRENT_ROAD_STATUS',
          item.tupuShow ? '1' : '0'
        );

        const another = [...this.entrancePointList];

        another.forEach(i => {
          i.isShow = item.tupuShow;
        });

        this.$store.commit('WindFarm/SET_ROADLIST', arr);
        this.$store.commit('WindFarm/UPDATE_ROAD_LIST');
        this.$store.commit('WindFarm/SET_KEYPOINTS', otherArr);
        this.$store.commit('WindFarm/UPDATE_KEY_POINTS');
        this.$store.commit('WindFarm/SET_ENTRANCELISTS', another);
        this.$store.commit('WindFarm/UPDATE_EXCLUSIVE_LIST');
      }

      if (item.name === '线路') {
        const arr = [...this.windfarmWireList];

        arr.forEach(i => {
          i.isShow = item.tupuShow;
        });

        sessionStorage.setItem(
          'CURRENT_LINE_STATUS',
          item.tupuShow ? '1' : '0'
        );

        this.$store.commit('WindFarm/SET_WIRE_LIST', arr);
        this.$store.commit('WindFarm/UPDATE_WIRE_LIST');
      }

      //console.log(item, index);
    }
  }
};
</script>

<style lang="less" scoped>
.farm-item-box {
  .item {
    user-select: none;
    display: flex;
    align-items: center;
    height: 35px;
    font-size: 12px;
    padding: 0px 10px 0px 22px;
    justify-content: space-between;
    cursor: pointer;
    &:hover {
      background-color: #a1c9e9;
    }
    &.is-disabled {
      color: #8c8c8c;
      cursor: not-allowed;

      .button,
      .result-show {
        color: #8c8c8c;
        cursor: not-allowed;

        &.is-disabled {
          color: #8c8c8c;
          cursor: not-allowed;
        }
      }
    }
    &.is-active {
      color: #fff;
      background-color: #0159ac;
      .button,
      .result-show {
        color: #fff;
      }
    }

    .button,
    .result-show {
      cursor: pointer;
      color: #0876bd;

      &.is-disabled {
        color: #999;
        cursor: not-allowed;
      }

      i {
        font-size: 16px;
        &.is-active {
          color: #3cc2e6;
        }
        &.is-not-active {
          color: #999;
        }
      }
    }
  }
}
</style>
